import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="auth-wrap">
      <div className="auth-card fade-up" style={{ textAlign: "center" }} data-testid="payment-cancel">
        <XCircle size={50} style={{ color: "var(--red)" }} />
        <h1 style={{ fontSize: 24, marginTop: 12 }}>Checkout cancelled</h1>
        <p className="ss-muted" style={{ marginTop: 6 }}>No charge was made. You can try again anytime.</p>
        <button className="ss-btn ss-btn-primary" style={{ marginTop: 18 }} onClick={() => navigate("/")} data-testid="back-home">Back to shopping</button>
      </div>
    </div>
  );
}
